import React from 'react';

const Footer = () => {
    return (
        <div className="app__static__footer__container">
            <div className="app__grid__row">
                <div
                    className="app__grid__column__four-one
                                    footer__column">
                    <div className="footer__columns__center-wrapper">
                        <div className="semi-bold">Find an adviser</div>
                        <div className="footer__link">
                            <a href="https://www.vouchedfor.co.uk/financial-advisor-ifa/">IFAs</a>
                        </div>
                        <div className="footer__link">
                            <a href="https://www.vouchedfor.co.uk/mortgage-advisor/">
                                Mortgage Advisers
                            </a>
                        </div>
                        <div className="footer__link">
                            <a href="https://www.vouchedfor.co.uk/solicitor/">Legal Advisers</a>
                        </div>
                        <div className="footer__link">
                            <a href="https://www.vouchedfor.co.uk/accountant/">Accountants</a>
                        </div>
                    </div>
                </div>

                <div
                    className="app__grid__column__four-one
                                    footer__column">
                    <div className="footer__columns__center-wrapper">
                        <div className="semi-bold">Company</div>
                        <div className="footer__link">
                            <a
                                href="http://about.vouchedfor.co.uk/about"
                                target="_blank"
                                rel="noreferrer">
                                About Us
                            </a>
                        </div>
                        <div className="footer__link">
                            <a
                                href="https://www.vouchedfor.co.uk/blog"
                                target="_blank"
                                rel="noreferrer">
                                Tips &amp; Guides
                            </a>
                        </div>
                        <div className="footer__link">
                            <a href="https://www.vouchedfor.co.uk/privacy-policy">
                                Legal &amp; Cookies
                            </a>
                        </div>
                    </div>
                </div>

                <div
                    className="app__grid__column__four-one
                                    app__grid__column__two-one--mobile
                                    footer__column">
                    <div className="footer__columns__center-wrapper">
                        <span className="semi-bold">VouchedFor professional?</span>
                        <div className="footer__link">
                            <a href="https://accounts.vouchedfor.co.uk/register">Sign up</a> |
                            <a href="https://accounts.vouchedfor.co.uk/">Log in</a>
                        </div>
                    </div>
                </div>

                <div
                    className="app__grid__column__four-one
                                    footer__column">
                    <div className="footer__columns__center-wrapper">
                        <span className="semi-bold">Social</span>
                        <div className="footer__link">
                            <a
                                href="https://www.facebook.com/pages/VouchedFor/158173767573318"
                                target="_blank"
                                rel="noreferrer">
                                Facebook
                            </a>
                        </div>
                        <div className="footer__link">
                            <a
                                href="https://twitter.com/VouchedFor"
                                target="_blank"
                                rel="noreferrer">
                                Twitter
                            </a>
                        </div>
                        <div className="footer__link">
                            <a
                                href="https://www.linkedin.com/company/vouchedfor"
                                target="_blank"
                                rel="noreferrer">
                                LinkedIn
                            </a>
                        </div>
                        <div className="footer__link">
                            <a
                                href="https://plus.google.com/105770956844370682123/posts"
                                target="_blank"
                                rel="noreferrer">
                                Google+
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer__row">
                <div>
                    VouchedFor LTD is a limited company registered in England and Wales with
                    registered number 07485300.
                </div>
                <div>
                    Our registered office and place of business is at 8 Waldegrave Road, Teddington,
                    Middlesex, TW11 8HT.
                </div>
                <div>
                    <span>© VouchedFor 2021 • </span>
                    <span>0203 111 0580</span>
                </div>
            </div>
        </div>
    );
};

export default Footer;
